import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/api/') && !req.url.includes('boxcloud')) {
      // With http-only cookies, the Authorization header is automatically sent by the browser
      // We don't need to manually add it
      const apiReq = req.clone({ withCredentials: true });
      return next.handle(apiReq).pipe(
        tap(
          e => {},
          err => {
            if (err?.status === 401) {
              console.log('Not authorized');
              // Handle logout by redirecting to login page
              // This avoids circular dependency by not injecting AuthService
              if (!window.location.href.endsWith('/login')) {
                window.location.href = '/login';
              }
            }
          },
        ),
      );
    } else {
      return next.handle(req);
    }
  }
}
